// extracted by mini-css-extract-plugin
export default {"popup":"CountriesCompactField__popup-tT1Cg"};